import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BaseChartDirective, Label } from 'ng2-charts';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { NbDialogService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'access-counter-chart',
  templateUrl: './access-counter-chart.component.html',
  styleUrls: ['./access-counter-chart.component.css']
})
export class AccessCounterChartComponent implements OnInit {

  @Input()
  public dateChartLabels: any[] = [];

  @Input()
  public countChartDataResident: any[] = [];

  @Input()
  public countChartDataEmployee: any[] = [];

  @Input()
  public countChartDataVisitorResidence: any[] = [];

  @Input()
  public countChartDataVisitorCompany: any[] = [];

  @Input()
  public countChartDataServiceProvider: any[] = [];

  @Input()
  public countChartDataTotal: string = "";

  @Input()
  public loadingChartData: boolean;

  @Input()
  public changeTypeChart: ChartType;

  @Output() chartAccessClicked: EventEmitter<any> = new EventEmitter();

  public spinner: boolean;

  public containsAccessData: boolean;

  public chartType: ChartType = 'bar';
  public chartPlugins = [];
  public lineChartColors:Array<any> = [
    // Residente
    {
      backgroundColor: 'rgba(0, 146, 206)',
      //borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    // Colaboradores
    {
      backgroundColor: 'rgba(107, 67, 155)',
      //borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    // Visitante residencia
    {
      backgroundColor: 'rgba(133, 202, 231)',
      //borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    // Visitante empresa
    {
      backgroundColor: 'rgba(183, 165, 205)',
      //borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    // Prestador de serviço
    {
      backgroundColor: 'rgba(228,64,151)',
      //borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    // Total geral
    {
      backgroundColor: 'rgba(255, 127, 80)',
      //borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
  ]
  public chartOptions: ChartOptions = {
    responsive: true,
    tooltips:{
      callbacks: {
        label: (tooltipItem, chartData) => {
          console.log(tooltipItem)
          console.log(chartData)

          var label = chartData.datasets[tooltipItem.datasetIndex].label;
          var labelFormated = label.replace('(', '').replace(')', '').replace(/[0-9]/g, '');

          var value = tooltipItem.value;
          return `${labelFormated} ${value}`;
        }
      }
    },
    scales: {
      xAxes: [{
        ticks: {
          fontColor: 'black',
        },
        gridLines: {
          color: '#ffffff'
        },
        stacked: true
      }],
      yAxes: [{
        ticks: {
          fontColor: 'black',
          min: 0,
          beginAtZero: false,
          precision: 0
        },
        gridLines: {
          color: '#ffffff'
        },
        scaleLabel: {
          display: false,
          labelString: 'Scale Label',
          fontColor: 'black',
        },
        stacked: true
      }]
    },
    legend: {
      display: true,
      labels: {
        fontColor: 'black'
      }
    },
  };

  public chartData: ChartDataSets[] = [
    { data: [],  label: ''},
    { data: [],  label: ''},
    { data: [],  label: ''},
    { data: [],  label: ''},
    { data: [],  label: ''},
    { data: [],  label: ''},
  ];
  
  public chartLabels: Label[] = [];

  @ViewChild(BaseChartDirective)
  public chart: any;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {}

  ngOnChanges(){
    this.chartData[0].label = `${this.translate.instant("ROLES.RESIDENT")} (${this.countChartDataResident.reduce((accumulator, value) => accumulator + value, 0)})`;
    this.chartData[1].label = `${this.translate.instant("ROLES.EMPLOYEE")} (${this.countChartDataEmployee.reduce((accumulator, value) => accumulator + value, 0)})`
    this.chartData[2].label = `${this.translate.instant("ROLES.VISITOR_RESIDENCE")} (${this.countChartDataVisitorResidence.reduce((accumulator, value) => accumulator + value, 0)})`
    this.chartData[3].label = `${this.translate.instant("ROLES.VISITOR_COMPANY")} (${this.countChartDataVisitorCompany.reduce((accumulator, value) => accumulator + value, 0)})`
    this.chartData[4].label = `${this.translate.instant("ROLES.SERVICE_PROVIDER")} (${this.countChartDataServiceProvider.reduce((accumulator, value) => accumulator + value, 0)})`
    this.chartData[5].label = `${this.translate.instant("DASHBOARD.PAGE.ACCESS_COUNTER.GRAND_TOTAL")} (${this.countChartDataTotal})`

    this.chartData[0].data = this.countChartDataResident;
    this.chartData[1].data = this.countChartDataEmployee;
    this.chartData[2].data = this.countChartDataVisitorResidence;
    this.chartData[3].data = this.countChartDataVisitorCompany;
    this.chartData[4].data = this.countChartDataServiceProvider;
    this.chartLabels = this.dateChartLabels

    this.chartType = this.changeTypeChart;
    this.spinner = this.loadingChartData;

    if(this.countChartDataResident.length != 0){
      this.containsAccessData = true;
    }else{
      this.containsAccessData = false;
    }
  }
}
